import { useEffect, useState } from 'react'

const useFooterHeight = () => {
  const [footerHeight, setFooterHeight] = useState(0)

  useEffect(() => {
    const footer = document.getElementById('footer')
    if (!footer) return 0

    const updateHeight = () => {
      const height = footer.getBoundingClientRect().height
      setFooterHeight(height)
    }

    updateHeight()

    const observer = new ResizeObserver(updateHeight)
    observer.observe(footer)

    return () => observer.disconnect()
  }, [])


  return footerHeight
}

export default useFooterHeight